import classNames from 'classnames';
import { MouseEventHandler } from 'react';

export enum CardType {
    DarkBlue,
    DarkRed,
    Red,
    Blue,
    Grey,
}

type Props = {
    children: React.ReactNode;
    disabled?: boolean;
    class?: string;
    className?: string;
    style?: React.CSSProperties;
    type?: CardType;
    onClick?: MouseEventHandler<HTMLDivElement>;
};
export function Card({
    disabled = false,
    type = CardType.Red,
    children,
    style,
    class: _class,
    className,
    ...props
}: Props) {
    return (
        <div
            {...props}
            style={{
                borderRadius: '20px',
                ...style,
            }}
            className={classNames(_class, className, 'p-20', {
                'bg-dark-blue': type === CardType.DarkBlue,
                'bg-dark-red': type === CardType.DarkRed,
                'bg-dark-red-10p': type === CardType.Red && !disabled,
                'border border-dashed border-dark-red bg-white':
                    type === CardType.Red && disabled,
                'bg-vibrant-blue-10p': type === CardType.Blue && !disabled,
                'border border-dashed border-vibrant-blue bg-white':
                    type === CardType.Blue && disabled,
                'bg-interactive-surface': type === CardType.Grey && !disabled,
                'border border-dashed border-interactive-surface bg-white':
                    type === CardType.Grey && disabled,
            })}
            inert={disabled ? '' : undefined}
        >
            {children}
        </div>
    );
}
